/**
 * 公共外观（导航 / 品牌标题 / AI 数字人）字段模型
 * 跨页面全局 chrome，由共享组件 src/components/layout/MainLayout.vue 渲染；
 * 前端用 $C(scope, key, default) 读取文字类项。
 *
 * AI 数字人视频已通过素材锚点 --cms-video-ai / --cms-video-ai-speak 经 $cmsMedia 接入
 * （见 src/cms/schema.js 的 ASSET_ANCHORS，以及 MainLayout.vue 中的两处 <video> 绑定），
 * 故 aiVideo / aiSpeak 字段仅作为后台分组展示与文档说明，实际资源仍由锚点机制驱动。
 */
export default {
  title: '公共外观（导航/标题/AI）',
  groups: [
    {
      title: '品牌与导航',
      fields: [
        { key: 'brandTitle', label: '顶部品牌标题', type: 'text', default: '酪蛋白工厂数字孪生可视化' },
        { key: 'back', label: '通用返回按钮', type: 'text', default: '返回' },
        { key: 'navInternational', label: '底部导航·国际市场', type: 'text', default: '国际市场' },
        { key: 'navChina', label: '底部导航·国内市场', type: 'text', default: '国内市场' },
        { key: 'navGanzi', label: '底部导航·甘孜市场', type: 'text', default: '甘孜市场' },
        { key: 'aiBtn', label: 'AI 对话按钮', type: 'text', default: 'AI对话' },
      ],
    },
    {
      title: 'AI 数字人视频',
      fields: [
        { key: 'aiVideo', label: 'AI 数字人待机视频（锚点 --cms-video-ai）', type: 'video', default: '' },
        { key: 'aiSpeak', label: 'AI 数字人讲话视频（锚点 --cms-video-ai-speak）', type: 'video', default: '' },
      ],
    },
  ],
}
